export enum FullScreenMode {
  SPLIT,
  FULL,
  FINAL_RANKING,
}
